<template>
  <table class="checklist-table">
    <tbody>
      <tr>
        <td>
          <v-radio-group v-model="form.liveOrProcessed" row>
            <v-radio label="Live" value="live" />
            <v-radio label="Processed" value="processed" />
          </v-radio-group>
        </td>
        <td class="text-h6" colspan="8">
          This checklist must completed daily when there are abalone in the purging.
        </td>
      </tr>
      <tr>
        <td>
          <DateField
            v-model="form.date"
            label="Packing Date"
            :filled="false"
          />
        </td>
        <td class="font-bold" v-for="(i) in 4" :key="i" colspan="2">
          Day {{ i }}
        </td>
      </tr>
      <tr>
        <td colspan="9">
          <div class="text-h5">
            Water quality parameters
          </div>
        </td>
      </tr>
      <tr v-for="(question, index) in questions" :key="index">
        <td>
          {{ question.text }}
        </td>
        <td colspan="2">
          <v-select
            v-if="question.options"
            :items="question.options"
            v-model="form[`${question.value}1`]"
          ></v-select>
          <v-text-field v-else v-model="form[`${question.value}1`]" />
        </td>
        <td colspan="2">
          <v-select
            v-if="question.options"
            :items="question.options"
            v-model="form[`${question.value}2`]"
          ></v-select>
          <v-text-field v-else v-model="form[`${question.value}2`]" />
        </td>
        <td colspan="2">
          <v-select
            v-if="question.options"
            :items="question.options"
            v-model="form[`${question.value}3`]"
          ></v-select>
          <v-text-field v-else v-model="form[`${question.value}3`]" />
        </td>
        <td colspan="2">
          <v-select
            v-if="question.options"
            :items="question.options"
            v-model="form[`${question.value}4`]"
          ></v-select>
          <v-text-field v-else v-model="form[`${question.value}4`]" />
        </td>
      </tr>
      <tr>
        <td colspan="9">
          <div class="text-h5">
            Water Quality: Flowrates & Air
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="d-flex">
            <v-select
              class="mr-5"
              :items="['Yes', 'No']"
              v-model="form.inside"
              label="Inside"
            ></v-select>
            <v-select
              :items="['Yes', 'No']"
              v-model="form.outside"
              label="Outside"
            ></v-select>
          </div>
        </td>
        <td class="fontweight-bold" v-for="(i) in 8" :key="i">
          {{ i % 2 === 1 ? 'AM' : 'PM' }}
        </td>
      </tr>
      <tr>
        <td class="text-right">
          Tank Number
        </td>
        <td class="fontweight-bold" v-for="(i) in 8" :key="i">
          <v-text-field v-model="form[`tank${i}`]" />
        </td>
      </tr>
      <tr v-for="(question, index) in tankQuestions" :key="index">
        <td>
          {{ question.text }}
        </td>
        <td v-for="(i) in 8" :key="`col-${index}-${i}`">
          <v-text-field v-model="form[`tank${i}${question.value}`]" />
        </td>
      </tr>
      <tr>
        <td colspan="9">
          <div class="text-h5">
            Abalone Condition
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <DateField label="Day 1 Date" :filled="false" />
        </td>
        <td class="text-right">
          <v-text-field label="Tank No" />
        </td>
        <td class="fontweight-bold" v-for="(i) in 7" :key="i">
        </td>
      </tr>
      <tr v-for="question in dayQuestions" :key="question">
        <td colspan="2">
          {{ question.text }}
        </td>
        <td v-for="(i) in 7" :key="`col-${question}-${i}`">
          <v-text-field v-model="form[`day${i}${question.value}`]" />
        </td>
      </tr>
      <tr>
        <td>
          <DateField label="Day 2 Date" :filled="false" />
        </td>
        <td class="text-right">
          <v-text-field label="Tank No" />
        </td>
        <td class="fontweight-bold" v-for="(i) in 7" :key="i">
        </td>
      </tr>
      <tr v-for="question in dayQuestions" :key="question">
        <td colspan="2">
          {{ question.text }}
        </td>
        <td v-for="(i) in 7" :key="`col-${question}-${i}`">
          <v-text-field v-model="form[`day${i}${question.value}`]" />
        </td>
      </tr>
      <tr>
        <td>
          <DateField label="Day 3 Date" :filled="false" />
        </td>
        <td class="text-right">
          <v-text-field label="Tank No" />
        </td>
        <td class="fontweight-bold" v-for="(i) in 7" :key="i">
        </td>
      </tr>
      <tr v-for="question in dayQuestions" :key="question">
        <td colspan="2">
          {{ question.text }}
        </td>
        <td v-for="(i) in 7" :key="`col-${question}-${i}`">
          <v-text-field v-model="form[`day${i}${question.value}`]" />
        </td>
      </tr>
      <tr>
        <td>
          <DateField label="Day 4 Date" :filled="false" />
        </td>
        <td class="text-right">
          <v-text-field label="Tank No" />
        </td>
        <td class="fontweight-bold" v-for="(i) in 7" :key="i">
        </td>
      </tr>
      <tr v-for="question in dayQuestions" :key="question">
        <td colspan="2">
          {{ question.text }}
        </td>
        <td v-for="(i) in 7" :key="`col-${question}-${i}`">
          <v-text-field v-model="form[`day${i}${question.value}`]" />
        </td>
      </tr>
      <tr>
        <td colspan="15">
          <v-textarea label="Comments">
          </v-textarea>
        </td>
      </tr>
      <tr>
        <td>
          Checklist completed by
        </td>
        <td class="text-right">
        </td>
        <td class="fontweight-bold" v-for="(i) in 7" :key="i">
          <PinDialog label="Sign" />
        </td>
      </tr>
      <tr>
        <td>
          Manager/Supervisor
        </td>
        <td class="text-right">
        </td>
        <td class="fontweight-bold" v-for="(i) in 7" :key="i">
          <PinDialog label="Sign" />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import DateField from '@/modules/processing/components/DateField.vue';
import PinDialog from '@/modules/processing/components/PinDialog.vue';

export default {
  name: 'PurgeChecklist',
  components: {
    DateField,
    PinDialog,
  },
  data() {
    return {
      form: {
        liveOrProcessed: 'live',
        date: new Date().toISOString().substr(0, 10),
      },
      dayQuestions: [
        {
          text: 'Number of bags in tank?',
          value: 'numberOfBags',
        },
        {
          text: 'Condition of abalone?',
          value: 'condition',
        },
      ],
      tankQuestions: [
        {
          text: 'Size Range',
          value: 'sizeRange',
        },
        {
          text: 'Flow Rate (seconds) in the tanks?',
          value: 'flowRate',
        },
        {
          text: 'Flow Rate (L/Kg/Hr) in the tanks?',
          value: 'flowRateL',
        },
        {
          text: 'Flow rates adjusted with flowmeter?',
          value: 'flowRateAdjusted',
        },
        {
          text: 'Volume of container used to measure flowrate?',
          value: 'volume',
        },
        {
          text: 'Air flow and pressure correct in tanks?',
          value: 'airFlow',
        },
        {
          text: 'Is there any foam in/on the water?',
          value: 'foam',
        },
      ],
      questions: [
        {
          text: 'What is the ph in the tanks?',
          value: 'ph',
        },
        {
          text: 'What is the DO (mgl) in the tanks?',
          value: 'mgl',
        },
        {
          text: 'What is the DO (%) in the tanks?',
          value: 'percentage',
        },
        {
          text: 'What is the temperature in the tanks?',
          value: 'temperature',
        },
        {
          text: 'Grading used? (Normal/Spawning/Warm Water)',
          value: 'grading',
          options: [
            'Normal',
            'Spawning',
            'Warm Water',
          ],
        },
        {
          text: 'Bag Stocking Density used? (Normal/Spawning/Warm Water)',
          value: 'bagStockingDensity',
          options: [
            'Normal',
            'Spawning',
            'Warm Water',
          ],
        },
        {
          text: 'Bag Stocking Density - weight of bag',
          value: 'bagStockingDensityWeight',
        },
      ],
    };
  },
};
</script>
<style>
.checklist-table {
    width: 100%;
    border-collapse: collapse;
  }

  .checklist-table td, .checklist-table th {
    border: 1px solid black;
    padding: 8px;
  }
</style>
